import { render, staticRenderFns } from "./exameAudiometria.vue?vue&type=template&id=bd65f334&"
import script from "./exameAudiometria.vue?vue&type=script&lang=js&"
export * from "./exameAudiometria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports